module.exports = __webpack_public_path__ + "static/weapon_of_warning-41f0c4e09588c7b62af0644d91b10de6.jpeg";